exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".weui-switch{-webkit-appearance:none}", "", {"version":3,"sources":["/./src/components/forms/input.vue"],"names":[],"mappings":"AACA,aACE,uBAAyB,CAC1B","file":"input.vue","sourcesContent":["\n.weui-switch {\n  -webkit-appearance: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-6a2e01c5!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/input.vue
// module id = 92
// module chunks = 0